import { LocalStateCategories } from './Categories.types'

export const CategoriesDefaultLocalState: LocalStateCategories = {
  filterInput: { textSearchFilter: '' },
  sortInput: null,
}
